import React from 'react';
import { Wrapper } from './styled';
import * as LogoClasificados from '@app/src/assets/img/logo-clasificados.png';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

export const Logo: React.FC = () => {
  const handleClick = () => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'MenuClasificados',
        'eventAction': 'Logo',
        'eventLabel': '',
        'eventValue': 1
      })
    }
  };

  return (
    <Wrapper
      href="/"
      onClick={() => handleClick()}>
      <img
        src={LogoClasificados}
        alt="clasificados.pe" />
    </Wrapper>
  );
};

Logo.displayName = 'Logo';
